import { isNumeric } from 'helpers';
import moment from 'moment';
import { isMoment } from 'moment';
import 'moment-timezone';

export const momentInstance = moment;

export const isObjectDate = (date) => {
  return Object.prototype.toString.call(date) === '[object Date]';
};

export const getDifferentTwoDate = (startDate, endDate, type = 'days') => {
  return moment(endDate).diff(startDate, type);
};

export const setTimeOfDateToDefault = (date, { hours = 0, minutes = 0, seconds = 0 } = {}) => {
  if (moment(date).isValid()) {
    const newDate = date;
    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    newDate.setSeconds(seconds);

    return newDate;
  }

  return '';
};

export const getDates = (startDate, stopDate, format = 'll') => {
  let dateArray = [];
  let currentDate = moment(startDate);
  let stopDateM = moment(stopDate);
  while (currentDate <= stopDateM) {
    dateArray = [...dateArray, moment(currentDate).format(format)];
    currentDate = moment(currentDate).add(1, 'days');
  }
  return [...dateArray, moment(stopDate).format(format)];
};

export const timeOnlineOffline = (ms) => {
  let days = Math.floor(ms / (24 * 60 * 60 * 1000));
  let daysms = ms % (24 * 60 * 60 * 1000);
  let hours = Math.floor(daysms / (60 * 60 * 1000));
  let hoursms = ms % (60 * 60 * 1000);
  let minutes = Math.floor(hoursms / (60 * 1000));
  let minutesms = ms % (60 * 1000);
  let sec = Math.floor(minutesms / 1000);
  return (
    (days > 0 ? days + ' day(s) ' : '') +
    (hours < 10 ? '0' + hours : hours) +
    ':' +
    (minutes < 10 ? '0' + minutes : minutes) +
    ':' +
    (sec < 10 ? '0' + sec : sec)
  );
};

export const filterByDateTime = (list, field, type) => {
  if (type === 'asc') {
    return list.sort((d1, d2) => new Date(d1[field]) - new Date(d2[field]));
  }

  if (type === 'desc') {
    return list.sort((d1, d2) => new Date(d2[field]) - new Date(d1[field]));
  }

  return;
};

export const convertTime12to24 = (time12h) => {
  const [time, modifier] = time12h.split(' ');

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};

export const parseTime24 = (time24h) => {
  const hour = time24h.split(':')[0];
  const minute = time24h.split(':')[1];
  return { hour, minute };
};

export const getTimeStamp = () => {
  return new Date().getTime();
};

export const getSuggestionSchedule = ({ timeWakeUp = '', timeZone = '' }) => {
  if (!timeWakeUp || !timeZone) {
    return '';
  }

  // timeWakeUp is time 12h
  const time24 = convertTime12to24(timeWakeUp);
  const { hour, minute } = parseTime24(time24);

  const currentTimeByTz = moment().tz(timeZone);
  const wakeUpTimeByTz = moment().tz(timeZone).set({ hour, minute, second: 0 });

  // if current time is before wakeUpTime
  if (currentTimeByTz.isBefore(wakeUpTimeByTz)) {
    return new Date(wakeUpTimeByTz.format('MMMM DD YYYY, h:mm:ss A'));
  }

  // else add 1 more day
  return new Date(
    currentTimeByTz
      .set({ hour, minute, second: 0 })
      .add(1, 'days')
      .format('MMMM DD YYYY, h:mm:ss A'),
  );
};

export const getMinDate = (timeZone) => {
  return timeZone
    ? new Date(moment().tz(timeZone).format('MMMM DD YYYY, h:mm:ss A'))
    : new Date(moment().format('MMMM DD YYYY, h:mm:ss A'));
};

export const convertDateTime = (time = '') => {
  return moment(time).format('lll');
};

export const getDateCurrent = (format = '') => {
  if (format) {
    return moment().format(format);
  }
  return moment();
};

export const getDaySubtractFromCurrent = (numberDay = 0, format = 'dateObj') => {
  if (format) {
    if (format === 'dateObj') {
      return moment().subtract(numberDay, 'd').toDate();
    }

    return moment().subtract(numberDay, 'd').format(format);
  }

  return moment().subtract(numberDay, 'd');
};

export function formatDate(date, pattern) {
  if (!date) return '';

  try {
    const momentInstance = moment(date);

    if (!momentInstance.isValid()) {
      console.warn('Invalid date provided to formatDate:', date);
      return '';
    }

    // Convert our custom pattern format to moment format
    const momentPattern = pattern
      .replace(/yyyy/g, 'YYYY')
      .replace(/MM/g, 'MM')
      .replace(/dd/g, 'DD')
      .replace(/HH/g, 'HH')
      .replace(/mm/g, 'mm')
      .replace(/ss/g, 'ss');

    return momentInstance.format(momentPattern);
  } catch (error) {
    console.warn('Error formatting date:', error);
    return '';
  }
}

export const convertDateByFormat = (date, format = 'YYYY/MM/DD') => {
  if (date) {
    return moment(date).format(format);
  }

  return '';
};

export const renderDurationTime = (duration = 0) => {
  const thisDuration = momentInstance.duration(duration)._data;
  return `${thisDuration.years ? `${thisDuration.years} years` : ''} ${
    thisDuration.months ? `${thisDuration.months} months` : ''
  } ${thisDuration.days ? `${thisDuration.days} days` : ''} ${
    thisDuration.hours ? `${thisDuration.hours} hours` : ''
  } ${thisDuration.minutes ? `${thisDuration.minutes} minutes` : ''}`;
};

export const parseDateToRequest = (date) => {
  if (date) {
    return convertDateByFormat(date, 'YYYY-MM-DD');
  }

  return null;
};

export const calculateTimeLeft = (timeLeft, { isMinimize } = { isMinimize: false }) => {
  if (moment(timeLeft).isValid()) {
    const duration = moment.duration(timeLeft);
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    const daysStr = isMinimize ? 'd' : ' days';
    const hoursStr = isMinimize ? 'h' : ' hours';
    const minutesStr = isMinimize ? 'min' : ' minutes';
    const secondsStr = isMinimize ? 's' : ' seconds';

    if (days) {
      return `${days}${daysStr} ${hours}${hoursStr} ${minutes}${minutesStr} ${seconds}${secondsStr}`;
    }

    if (hours) {
      return `${hours}${hoursStr} ${minutes}${minutesStr} ${seconds}${secondsStr}`;
    }

    if (minutes) {
      return `${minutes}${minutesStr} ${seconds}${secondsStr}`;
    }

    if (isNumeric(seconds)) {
      return `${seconds}${secondsStr}`;
    }

    return '';
  }

  return '';
};

export const timeBetween2Dates = (startDate, endDate, options = { isABS: false }) => {
  const { isABS } = options || {};

  //* startDate + endDate must be moment object
  if (!isMoment(startDate) || !isMoment(endDate)) {
    return 'Date is invalid!';
  }

  const date1 = startDate.milliseconds(0);
  const date2 = endDate.milliseconds(0);

  let diffInDays = date2.diff(date1, 'days');
  let diffInHours = date2.diff(date1, 'hours');
  let diffInMinutes = date2.diff(date1, 'minutes') % 60;
  let diffInSeconds = date2.diff(date1, 'seconds') % 60;

  let remainingHours = endDate.diff(startDate.add(diffInDays, 'days'), 'hours');
  let remainingMinutes = endDate.diff(startDate.add(remainingHours, 'hours'), 'minutes');
  let remainingSeconds = endDate.diff(startDate.add(remainingMinutes, 'minutes'), 'seconds');

  if (isABS) {
    diffInDays = Math.abs(diffInDays);
    diffInHours = Math.abs(diffInHours);
    diffInMinutes = Math.abs(diffInMinutes);
    diffInSeconds = Math.abs(diffInSeconds);

    remainingHours = Math.abs(remainingHours);
    remainingMinutes = Math.abs(remainingMinutes);
    remainingSeconds = Math.abs(remainingSeconds);
  }

  return {
    days: diffInDays,
    hours: diffInHours,
    minutes: diffInMinutes,
    seconds: diffInSeconds,
    remaining: `${diffInDays ? `${diffInDays}d` : ''} ${
      remainingHours ? `${remainingHours}h` : ''
    } ${remainingMinutes ? `${remainingMinutes}m` : ''} ${
      (!diffInDays && !remainingHours && !remainingMinutes) || remainingSeconds
        ? `${remainingSeconds}s`
        : ''
    }`.trim(),
  };
};

export const checkDateIsValid = (date) => {
  return moment(date, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid();
};

export const utcToLocalTime = (time, format) => {
  const offset = momentInstance().utcOffset();
  return momentInstance
    .utc(time)
    .utcOffset(offset)
    .format(format || 'lll');
};

export const localTimeToUTC = (time, format) => {
  return momentInstance(time)
    .utc()
    .format(format || 'YYYY-MM-DD HH:mm:ss');
};

export const utcToLocalTimeWithFormat = (time, formatUnit) => {
  const timeObj = moment(time, formatUnit || 'YYMMDDHHmm').toObject();
  return new Date(
    Date.UTC(
      timeObj.years,
      timeObj.months,
      timeObj.date,
      timeObj.hours,
      timeObj.seconds,
      timeObj.milliseconds,
    ),
  );
};

export const encodeTime = (time) => {
  return moment(time).format('YYYYMMDDHH');
};

export const decodeTime = (time) => {
  return moment(time, 'YYYYMMDDHHmm').toDate();
};

export const decodeTimeWithFormat = (time, formatFrom, formatTo) => {
  return moment(time + '', formatFrom).format(formatTo);
};

export const decodeTimeFromTimestamp = (time, format) => {
  return moment(new Date(time)).format(format);
};

export const convertDurationStats = (minutes) => {
  const second = minutes * 60;

  const h = Math.floor(second / 3600)
      .toString()
      .padStart(2, '0'),
    m = Math.floor((second % 3600) / 60)
      .toString()
      .padStart(2, '0'),
    s = Math.floor(second % 60)
      .toString()
      .padStart(2, '0');

  return h + ':' + m + ':' + s;
  //return `${h}:${m}:${s}`;
};

//* Using for parse date ranges to put into request body
export const parseDateRangesForFilters = ({ from, to, format = '', timeNow = false } = {}) => {
  if (!from && !to) {
    return {};
  }

  let fromResult = null;
  let toResult = null;

  const timeNowFormat = timeNow ? undefined : 'day';

  if (!!from) {
    fromResult = format
      ? momentInstance(from).startOf(timeNowFormat).format(format)
      : momentInstance(from).startOf(timeNowFormat);
    if (!to) {
      toResult = format
        ? momentInstance().endOf(timeNowFormat).format(format)
        : momentInstance().endOf(timeNowFormat);
    }
  }

  if (!!to) {
    toResult = format
      ? momentInstance(to).endOf(timeNowFormat).format(format)
      : momentInstance(to).endOf(timeNowFormat);
    if (!from) {
      fromResult = format
        ? momentInstance(to).startOf(timeNowFormat).format(format)
        : momentInstance(to).startOf(timeNowFormat);
    }
  }

  return {
    dateFrom: fromResult,
    dateTo: toResult,
  };
};

export function calculateTimeRemainingCampaign(total, processed, speed) {
  //* Speed (unit per second)
  const remaining = total - processed;
  if (speed <= 0 || remaining <= 0) {
    return 0;
  }

  const timeRemainingInSeconds = remaining / speed;

  const hours = Math.floor(timeRemainingInSeconds / 3600);
  const minutes = Math.floor((timeRemainingInSeconds % 3600) / 60);
  const seconds = Math.floor(timeRemainingInSeconds % 60);

  return { hours, minutes, seconds };
}

/*
 * Get UTC offset string
 * @param {Date} date - Date object
 * @returns {string} UTC offset string
 */
export const getUTCOffsetString = (date = new Date()) => {
  const offsetMinutes = -date.getTimezoneOffset();

  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
  const minutes = String(absMinutes % 60).padStart(2, '0');

  return `${sign}${hours}:${minutes}`;
};
